import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { ConfigurationService } from '../services/configuration/configuration.service';
import { UrlService } from '../services/url/url.service';

export const isEnabledViewCancelReservation: CanActivateFn =
    (): Observable<boolean> => {
        const configuration = inject(ConfigurationService);
        const url = inject(UrlService);
        const router = inject(Router);

        return configuration.requestFeatureFlags().pipe(
            switchMap((item) => {
                configuration.featuresFlags.next(item);
                const isEnabled = item.viewCancelReservation === true;
                if (!isEnabled) {
                    router.navigateByUrl(url.format(''));
                }
                return of(isEnabled);
            }),
        );
    };
